"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = _interopRequireDefault(require("./base"));
var _util = require("../../util");
var _excluded = ["className"];
var bem = (0, _util.klass)('pf-buttons');
var Link = function Link(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_base.default, Object.assign({}, props, {
    className: (0, _util.addClassNames)(className, bem('link'))
  }));
};
Link.propTypes = {
  className: _propTypes.default.string
};
Link.defaultProps = {
  className: ''
};
var _default = exports.default = Link;
